import { uploadRestaurantLogoFileHttps } from "../../redux/restaurantsSlice";
import { store } from "../../redux/store";

interface UploadedImgDetails {
  fileExtension: string;
  formData: any;
  documentType: string;
}

export const uploadIDDocImage = async (
  uploadLogoFileExtetion: (data: { fileExtension: string, documentType: string }) => Promise<any>,
  uploadedImgDetails: UploadedImgDetails
): Promise<string> => {

  try {
    const uploadLogoFIleExtentionResult = await uploadLogoFileExtetion({
      fileExtension: uploadedImgDetails.fileExtension,
      documentType: uploadedImgDetails.documentType
    });
    const imageUploadUrl = uploadLogoFIleExtentionResult.data.imageUploadUrl;

    await store.dispatch(
      uploadRestaurantLogoFileHttps({
        url: imageUploadUrl,
        body: uploadedImgDetails.formData,
        extention: uploadedImgDetails.fileExtension,
      })
    );
    return uploadLogoFIleExtentionResult.data.imageReference;
  } catch (error) {
    console.log("error in upload image", error);
    throw error;
  }
};
